// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOperationProgress {
}
